import * as THREE from 'three'
import { Helper } from '../../../../classes/helper'
import { useMeasures } from '../../../../hooks/state/useMeasures'
import { useSidewall } from '../../../../hooks/state/useSidewall'
import { SideTie } from '../window/side/tie/SideTie'
import { WindowsSideGlassTop } from '../window/side/glass/WindowsSideGlassTop'

export const Wedge = (): JSX.Element => {
  const {
    spaceBetween,
    sidwallTyp,
    triangularDivider,
    wedgeCut,
    hasWedege,
    sideWallType,
    wedgeLogWidth,
    wedgeLogDepth,
  } = useSidewall()
  const {
    eaves,
    userAngle,
    userHeight,
    depth,
    attachedSize,
    schwelleSize,
    isQubus,
    eavesWidth,
  } = useMeasures()
  const height = Helper.calculateTriangleSideLength(
    userAngle,
    90,
    depth - attachedSize.z - schwelleSize.depth - (eaves ? eavesWidth : 0)
  ).a

  const wedgeTyp =
    hasWedege && sideWallType !== 'keil'
      ? {
          log: {
            width: wedgeLogWidth / 100,
            depth: wedgeLogDepth / 100,
          },
          glas: (1.2 as number) / 100,
        }
      : {
          log: { width: sidwallTyp.log.width, depth: sidwallTyp.log.depth },
          glas: sidwallTyp.glas,
        }

  return (
    <group position={[0, userHeight - (height + wedgeCut), 0]}>
      <SideTie
        size={[
          height + wedgeCut + wedgeTyp.log.width,
          wedgeTyp.log.width,
          wedgeTyp.log.depth,
        ]}
        rotation={[
          Helper.convertAngleToRadiant(0),
          Helper.convertAngleToRadiant(90),
          Helper.convertAngleToRadiant(90),
        ]}
        position={[
          0,
          (height + wedgeCut) / 2,
          (-spaceBetween + wedgeTyp.log.width) / 2,
        ]}
      />

      {wedgeCut && (
        <SideTie
          size={[
            isQubus
              ? height + wedgeCut + wedgeTyp.log.width
              : wedgeCut + wedgeTyp.log.width * 2,
            wedgeTyp.log.width,
            wedgeTyp.log.depth,
          ]}
          rotation={[
            Helper.convertAngleToRadiant(0),
            Helper.convertAngleToRadiant(90),
            Helper.convertAngleToRadiant(90),
          ]}
          position={[
            0,
            isQubus ? (height + wedgeCut) / 2 : wedgeCut / 2,
            (spaceBetween - wedgeTyp.log.width) / 2,
          ]}
        />
      )}

      <SideTie
        size={[spaceBetween, wedgeTyp.log.width, wedgeTyp.log.depth]}
        rotation={[
          Helper.convertAngleToRadiant(0),
          Helper.convertAngleToRadiant(90),
          Helper.convertAngleToRadiant(0),
        ]}
        position={[0, -wedgeTyp.log.width / 2, 0]}
      />

      <WindowsSideGlassTop />

      {[...Array(triangularDivider)].map((_, index) => {
        const groundLength = isQubus
          ? height + wedgeCut + wedgeTyp.log.width
          : Helper.calculateTriangle(
              triangularDivider === 1
                ? spaceBetween / 2 + (eaves ? 0.3 : 0.4)
                : (spaceBetween / (triangularDivider + 1)) * (index + 1) +
                    (eaves ? 0.3 : 0.4),
              90,
              userAngle
            ).c + wedgeCut

        const space =
          (spaceBetween + wedgeTyp.log.width) / (triangularDivider + 1)
        const positionZ =
          triangularDivider === 1
            ? -wedgeTyp.log.width / 2
            : triangularDivider === 3
            ? index
              ? space * -(index - 1)
              : space
            : index
            ? (space / 2) * -index
            : space / 2

        return (
          <SideTie
            key={`WindowsSideTieCenter${index}`}
            size={[groundLength, wedgeTyp.log.width, wedgeTyp.log.depth]}
            rotation={[
              Helper.convertAngleToRadiant(0),
              Helper.convertAngleToRadiant(90),
              Helper.convertAngleToRadiant(90),
            ]}
            position={[0, groundLength / 2, positionZ]}
          />
        )
      })}
    </group>
  )
}
